import { render, staticRenderFns } from "./lotteryRecord.vue?vue&type=template&id=37e0fd87&scoped=true"
import script from "./lotteryRecord.vue?vue&type=script&lang=js"
export * from "./lotteryRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0fd87",
  null
  
)

export default component.exports